<template>
	<div class="orderinport">
		<el-form :style="{ height: `${windowHeight}px`, 'overflow-y': 'auto' }">
			<el-row>
				<el-col :span="24">
					<el-card class="box-card" label="导入账号" shadow="hover">
						<div slot="header" class="clearfix"><span>导入账号</span></div>
						<div>
							<el-autocomplete
								ref="u_account"
								:trigger-on-focus="false"
								v-model="user.u_account"
								:fetch-suggestions="searchvip"
								placeholder="请输入账号\姓名"
								@select="checkuser"
								value-key="u_account"
								size="small"
								style="width:300px" 
								@change="val =>changeuser(val)"
							>
								<template slot-scope="{ item }">
									<div> {{ item.u_name }} ({{ item.u_account }} )</div>
								</template>
							</el-autocomplete>
							<label style="margin-left:10px;font-size:10pt;color:#ee8b1a">可输入用户账号进行代导入</label>
						</div>
					</el-card>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="24" v-if="pmodelist.length > 1">
					<el-card class="box-card" label="选择渠道" shadow="hover">
						<div slot="header" class="clearfix"><span>选择渠道</span></div>
						<div>
							<el-select size="mini" v-model="checkedpmode" @change="selectpmode" style="width:200px">
								<el-option v-for="(i, idx) in pmodelist" :key="idx" :label="i.d_name" :value="i.d_name"></el-option>
							</el-select>
							<label style="margin-left:10px;font-size:10pt;">{{ p_mode_remark }}</label>
						</div>
					</el-card>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="24">
					<el-card class="box-card" label="选择文件" style="text-align: center;">
						<div slot="header" class="clearfix" style="text-align: left;">
							<span>选择文件</span>
							<span @click="downmode" style="color:#0066CC;text-decoration: underline;cursor:pointer;">(导入模板)</span>
						</div>
						<el-upload
							name="fileupload"
							drag
							:action="fileurl"
							:multiple="false"
							:limit="1"
							accept=".xlsx,.xls"
							auto-upload
							:on-success="UploadSuccess"
							:on-error="UploadError"
							:on-change="UploadChange"
							:show-file-list="false"
							:before-upload="UploadBefore"
							ref="upload"
							:file-list="filelist"
						>
							<i class="el-icon-upload"></i>
							<div class="el-upload__text">
								将文件拖到此处，或
								<em>点击上传</em>
								<br />
								( 支持 .xlsx .xls 文件 )
							</div>
						</el-upload>
						<div style="width:100%;text-align:center;">{{ filename }}</div>
					</el-card>
				</el-col>
			</el-row>
			<el-row v-show="isshowaddr" style="margin-bottom: 10px;">
				<el-col :span="24"><senderaddr ref="senderaddr" title="寄件信息" :l_mode="l_mode"></senderaddr></el-col>
			</el-row>
			<el-row v-if="!btnhidden" class="footerhandler">
				<el-col :span="6" class="submitBtn_switch" style="text-align: right;color:transparent">1</el-col>
				<el-col :span="4" class="submitBtn"><div @click="saveinportorder">导  入</div></el-col>
				<el-col :span="4" class="submitBtn_cancel"><div @click="cancel">取消</div></el-col>
			</el-row>
		</el-form>
		<el-dialog :visible.sync="showsuccesswin" title="操作提示" width="500px" :close-on-click-modal="false" lock-scroll :show-close="false" :append-to-body="true">
			<el-row style="padding-bottom:20px;margin-top:-20px">
				<el-col style="text-align:center" v-if="error != ''">
					<i class="el-icon-error" style="color:#ff8419;font-size:55pt;"></i>
					<br />
					<br />
					<span style="font-size:15pt;font-weight: bold">{{ error }}</span>
				</el-col>
				<el-col style="text-align:center" v-if="error == ''">
					<i class="el-icon-success" style="color:#80CBC4;font-size:55pt;"></i>
					<br />
					<br />
					<span style="font-size:20pt;font-weight: bold">成功导入{{ successcount }}个订单,是否继续操作?</span>
				</el-col>
			</el-row>
			<el-row v-if="errorfile != ''">
				<el-col :span="10" style="text-align:right;padding-right: 20px;">
					<el-button type="warning" size="medium"><a :href="errorfile" target="_blank" style="color:#ffffff;text-decoration:none;">下载详情</a></el-button>
				</el-col>
				<el-col :span="6"><el-button type="primary" size="medium" @click="successfun(2)">重新导入</el-button></el-col>
				<el-col :span="4" style="text-align:left;"><el-button size="medium" @click="successfun(0)">关闭</el-button></el-col>
			</el-row>
			<el-row v-if="errorfile == '' && error != ''">
				<el-col :span="12" style="text-align:right;"><el-button type="primary" size="medium" @click="successfun(2)">重新导入</el-button></el-col>
				<el-col :span="5" style="text-align:center;"><el-button size="medium" @click="successfun(0)">关闭</el-button></el-col>
			</el-row>
			<el-row v-if="errorfile == '' && error == ''">
				<el-col :span="12" style="text-align:right;"><el-button type="success" size="medium" @click="successfun(1)">继续导入</el-button></el-col>
				<el-col :span="5" style="text-align:center;"><el-button size="medium" @click="successfun(0)">关闭</el-button></el-col>
			</el-row>
		</el-dialog>
	</div>
</template>
<script>
import Utils from '../../lib/util.js';
import senderaddr from '@/components/address/senderaddr_ssq.vue';
export default {
	components: {
		senderaddr
	},
	props: {
		urlparam: {
			type: Object,
			default: {}
		}
	},
	data() {
		return {
			windowHeight: window.innerHeight - 150,
			checkedpmode: '',
			isshowaddr: false,
			fileurl: '',
			mode: '', //业务模块名称
			uploadfileurl: '', //上传之后保存下来的临时文件路径
			filename: '',
			tid: '',
			filelist: [],
			checktype: '0', //导入完成之后需要执行的业务方法
			btnhidden: false,
			p_batch: '', //导入成功之后的批次号
			l_name: '',
			downpath: localStorage.getItem('c_folder') + '/导入模版.zip', //导入模板路径
			error: '',
			errorfile: '',
			showsuccesswin: false,
			successcount: 0,
			type: '',
			syscol:'',
			pmodelist:[],
			l_mode:'',
			user:{
				u_userid:localStorage.getItem('userid'),
				u_account:localStorage.getItem('u_account')
			}
		};
	},
	mounted() {
		this.$apipost.get.getTheme().then(res => {
			import('../../static/' + res + '/style/packagemanager/orderinport.scss');
		});
		if (this.urlparam.mode != undefined) {
			this.mode = this.urlparam.mode;
		}
		if (this.urlparam.l_name != undefined) {
			this.l_name = this.urlparam.l_name;
			//console.log('l_name', this.urlparam.l_name);
		}
		//debugger
		this.GetClarance();
	},
	methods: {
		downmode(){
			//debugger
			this.$tool.DownFileByurl(this.$apiprototype.modeSever+'/'+this.downpath,'导入模板.zip');
		},
		//获取渠道
		GetClarance() {
			var that = this;
			this.$tool.loading('正在加载', this.divclass);
			//先加载渠道
			this.$apipost.get.GetClarance().then(res => {
				this.$tool.loadingclose();
				that.pmodelist = res.list;
				if (that.pmodelist.length > 0) {
					that.checkedpmode = that.pmodelist[0].d_name;
					that.p_mode_remark = that.pmodelist[0].remark;
					that.fileurl =
						that.$apiprototype.ApiServer + '/Order/checkexcelfile?domain=' + that.$apiprototype.WebServer + '&mode=' + that.checkedpmode + '&userid='+that.user.u_userid;
				}
			});
		},
		//切换渠道
		selectpmode(value) {
			var that=this;
			if(this.uploadfileurl!=''){
				this.$confirm('更改渠道需要重新再上传文件，确认继续操作吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					closeOnClickModal: false
				})
					.then(() => {
						that.selectmode2(value);
					});
			}
			else
				this.selectmode2(value);
		},
		selectmode2(value){
			var remark = '';
			this.pmodelist.forEach(e => {
				if (e.d_name == value) {
					remark = e.remark;
					return false;
				}
			});
			this.p_mode_remark = remark;
			this.uploadfileurl='';
			this.filename='';
			this.tid='';
			this.type = '';
			this.isshowaddr = false;
			this.checktype = '0';
			this.syscol = '';
			this.fileurl =
				this.$apiprototype.ApiServer + '/Order/checkexcelfile?domain=' + this.$apiprototype.WebServer + '&mode=' + this.checkedpmode +  '&userid='+this.user.u_userid;
		},
		UploadSuccess(res, file, fileList) {
			this.$tool.loadingclose();
			var that=this;
			if (res.state == '1') {
				this.uploadfileurl = res.fileurl;
				this.filename = res.filename;
				this.tid = res.tid;
				this.type = res.type;
				this.isshowaddr = res.isaddr === 'true' ? true : false;
				this.checktype = res.checktype;
				this.syscol = res.syscol;
				if (that.isshowaddr) {
					
					if(that.type.indexOf('进口')>-1)
						that.l_mode='寄件人信息-进口';
					else if(that.type.indexOf('出口')>-1)
						that.l_mode='寄件人信息-出口';
					that.syscol=that.syscol+',ctcompany,ctcountry,ctname,ctphone,ctprovince,ctcity,ctdistrict,ctstreet,ctdetailaddr,ctpostcode,ctaddressall'
					this.$nextTick(function() {
						that.$refs.senderaddr.init({ syscol: that.syscol });
					});
				}
			} else {
				this.filename = '';
				this.$tool.message(res.message, 0);
			}
			if(this.$refs.upload!=undefined)
				this.$refs.upload.clearFiles();
			else{
				if(this.$refs.upload.length>0)
					this.$refs.upload[0].clearFiles();
			}
		},
		UploadError(err, file, fileList) {
			console.log('上传错误 error', err);
		},
		UploadChange(file, fileList) {
			if (fileList.length > 0) this.$tool.loading('正在检测文件', 'orderinport');
		},
		UploadBefore(file){
			if(this.user.u_userid=='')
			{this.$tool.loadingclose();
				if(this.$refs.upload!=undefined){
					this.$refs.upload.clearFiles();
					this.$refs.upload.abort();
				}
				else{
					if(this.$refs.upload.length>0)
					{
						this.$refs.upload[0].clearFiles();
						this.$refs.upload[0].abort();
					}
				}
				this.$tool.message('请选择导入账号', 0);
			}
		},
		//保存
		saveinportorder() {
			var that = this;
			var inportinfo = new Object();
			inportinfo = this.checkdata(inportinfo);
			if (inportinfo != '') {
				this.$tool.loading('正在导入', 'orderinport');
				//console.log('inportinfo', JSON.stringify(inportinfo));
				//console.log('inportinfo',encodeURIComponent(JSON.stringify(inportinfo)));
				// if (1 < 2) {
				// 	return false;
				// }
				this.$apipost.post.SaveInport({ inportinfo: JSON.stringify(inportinfo) }).then(res => {
					if (res != '') {
						that.packageinportcomplete(res);
					} else {
						this.$tool.loadingclose();
						this.$tool.message('导入异常，请重试', 0);
					}
				});
			}
		},
		//验证包裹信息必填项
		checkorderdata(inportinfo) {
			var error = '';
			var that=this;
			if (this.isshowaddr) {
				var sender = '',
					receiver = '',
					orderlist = [];
				var setlist = this.$refs.senderaddr._data.setlist;
				if (setlist.length > 0) {
					setlist.forEach(e => {
						if (e.value == undefined) {
							e.value = '';
						}
						if (e.isnull == 'False' && e.value == '' && e.ishidden == 'False') {
							error = '请填写' + that.$refs.senderaddr.title + '-' + e.showname;
							sender = '';
						} else {
							if (error == '') {
								if (e.coltype == 'idcard' && e.isnull == 'False' && e.ishidden == 'False') {
									if (!that.$tool.checkidcardformat(e.value)) {
										error = that.$refs.senderaddr.title + '-' + e.showname + '格式不正确';
										sender = '';
									}
								}
							}
						}
						if (error == '') sender += '"' + e.colname + '":"' + e.value + '",';
						else return false;
					});
					if (error == '') {
						if (sender != '') {
							sender = sender.replace(/\n/g, '');
							sender = '{' + sender.substring(0, sender.length - 1) + '}';
							inportinfo.sender = JSON.parse(sender);
						}
					}
				}
			}
			if (error != '') {
				this.$tool.message(error, 0);
				return '';
			} else {
				return inportinfo;
			}
		},
		//检测信息
		checkdata(inportinfo) {
			var error = '';
			inportinfo.fileurl = this.uploadfileurl;
			inportinfo.tid = this.tid;
			inportinfo.u_userid =this.user.u_userid;
			inportinfo.u_account=this.user.u_account;
			inportinfo.handleuaccount=localStorage.getItem('u_account');
			if(this.user.u_userid=='')
				error = '请选择导入账号';
			if (inportinfo.fileurl == '' || inportinfo.fileurl == undefined) {
				error = '请上传文件';
			} else {
				inportinfo = this.checkorderdata(inportinfo);
			}
			if (error == '') {
				return inportinfo;
			} else {
				this.$tool.message(error, 0);
				return '';
			}
		},
		//导入之后执行的方法
		packageinportcomplete(res) {
			var that = this;
			if (res.state == '1') {
				that.p_batch = res.batch;
				that.successcount = res.count;
				//debugger
				//解析地址
				if(this.$parent.$parent.$parent.$refs.desktop!=undefined)
					this.$parent.$parent.$parent.$refs.desktop[0].ThreadResolve(that.p_batch);
				else
					this.$parent.$parent.$parent.$parent.$refs.desktop[0].ThreadResolve(that.p_batch);
					
				if(this.isshowaddr){
					var orderinfo=this.checkorderdata({});
					if(orderinfo.sender!=undefined){
						var paraminfo = { u_userid: localStorage.getItem('userid') };
						for (var j in orderinfo.sender) {
							var colname = j.substring(2, j.length);
							paraminfo[colname] = orderinfo.sender[j];
						}
						this.$apipost.post.SaveaddressCt({ paraminfo: paraminfo }).then(res => {
						});
					}
				}
				
				that.handlecomplete(res.batch);
			} else {
				that.showsuccesswin = true;
				this.$tool.loadingclose();
				that.error = res.message;
				if (res.localfilename != undefined) {
					if(res.localfilename!='')
						this.$tool.downfile(this, res.localfilename);
				}
			}
		},
		//导入成功事件1
		handlecomplete(batch) {
			var that = this;
			if (that.checktype == '1' || that.checktype == '2') {
				//检测商品库
				this.$apipost.get.MatchOrderCargo({ p_batch: batch }).then(res => {
					if (res.state == '1') {
						if (that.checktype == '2') {
							//计算税金
							this.$apipost.get.Calculatetaxfee({ p_batch: batch }).then(res => {
								that.showsuccesswin = true;
							});
						} else {
							that.showsuccesswin = true;
						}
					} else {
						this.$tool.loadingclose();
						that.error = res.message;
						if (res.localfilename != undefined) {
							if(res.localfilename!='')
								this.$tool.downfile(that, res.localfilename);
							that.showsuccesswin = true;
						}
					}
				}).catch(e=>{
					this.$tool.message('网络异常，请重试', 0);
				});
			}
			else if(this.checktype=='3'){//推送物流到第三方平台
				this.$apipost.post.ImportOrderPush({ p_batch: batch }).then(res => {
					this.$tool.loadingclose();
					if(res.state=='1'){
						that.showsuccesswin = true;
					}else{
						this.$tool.loadingclose();
						that.error = res.message;
						if (res.localfilename != undefined) {
							if(res.localfilename!='')
								this.$tool.downfile(that, res.localfilename);
							that.showsuccesswin = true;
						}
					}
				});
			}
			else {
				this.$tool.loadingclose();
				that.showsuccesswin = true;
			}
		},
		successfun(type) {
			this.showsuccesswin = false;
			this.filename = '';
			this.error = '';
			this.errorfile = '';
			this.p_batch = '';
			this.successcount = 0;
			this.uploadfileurl = '';
			this.checktype='';
			if (type == 0) Utils.$emit('handleRermove', localStorage.getItem('tabname'));
			else if (type == 1) {
				//清空再导入
				//this.SetPageLayout();
			}
		},
		cancel() {
			this.$emit('cancel');
		},
		formScrollTop() {
			this.$emit('formScrollTop');
		},
		GetSearchObj() {
			var searchinfo = {
				searchbox: this.user.u_account
			};
			return searchinfo;
		},
		searchvip(val, cb) {
			var that = this;
			setTimeout(function() {
				if (val != '') {
					//获取会员卡列表
					var paraminfo = {
						mode: '会员列表',
						tab: '',
						search: that.GetSearchObj(),
						pageindex: 0,
						pagesize: 20,
						sort: '',
						iscount: 0,
						showcol: ''
					};
					that.$apipost.get.GetGridTable({ paraminfo: paraminfo }).then(res => {
						cb(res.data);
					});
				}else{
					this.user={
						u_userid:'',
						u_account:''
					}
				}
			}, 300);
		},
		checkuser(val) {
			this.user={
				u_userid:val.u_userid,
				u_account:val.u_account
			}
			this.fileurl =
				this.$apiprototype.ApiServer + '/Order/checkexcelfile?domain=' + this.$apiprototype.WebServer + '&mode=' + this.checkedpmode +  '&userid='+this.user.u_userid;
		},
		changeuser(val){
			this.user={
				u_userid:''
			}
		}
	}
};
</script>
